import axios from 'axios';
import store from '../vuex/store'
import router from '../router';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

export {
    loginreq,
    req
}

// 请求拦截器
axios.interceptors.request.use(function(config) {
    //设置验证码jwt令牌
    let verificationJwt = store.getters.getVerificationJwt;
    if (verificationJwt) {
        config.headers['verificationJwt'] = verificationJwt;
    }

    var jwt = store.getters.getJwt;
    config.headers['jwt'] = jwt;
    return config;
}, function(error) {
    return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use(function(response) {
    // if (response.data.status === "401") {
    //     store.commit('logout', 'false')
    //     router.push({ path: '/login' })
    //     this.$message({
    //         type: 'success',
    //         message: '授权已过期，请重新登录!'
    //     })
    // }
    // if(response.data.status == "200"){
    //     this.$message({
    //         type: 'success',
    //         message: '操作成功!'
    //     })
    // }
    //保存验证码jwt令牌
    let verificationjwt = response.headers['verificationjwt'];
    if (verificationjwt) {
        console.log(verificationjwt)
        store.commit('setVerificationJwt', {
            verificationJwt: verificationjwt
        });
    }
    var jwt = response.headers['jwt'];
    if (jwt) {
        store.commit('setJwt', {
            jwt: jwt
        });
    }
    return response;
}, function(err) {
    let message = "网络错误";
    if (err && err.response && err.response.status) {
      switch (err.response.status) {
        case 500:
          message = "服务器在思考人生，请稍后再试";
          break;
        case 400:
          message = "操作失败！";
          break;
        case 401:
          message = "授权失败，请重新登录";
          store.commit('logout', 'false')
          router.push({ path: '/login' })
          break;
        case 404:
          message = "无法访问资源";
          break;
        default:
          message = "网络错误";
          break;
      }
    }
    err.response.statusText = message;

    return Promise.reject(err);
});


// WEBPACK FOOTER //
// ./src/api/axiosFun.js